import { render, staticRenderFns } from "./TableCmp.vue?vue&type=template&id=b60a6a2a&scoped=true"
import script from "./TableCmp.vue?vue&type=script&lang=js"
export * from "./TableCmp.vue?vue&type=script&lang=js"
import style0 from "./TableCmp.vue?vue&type=style&index=0&id=b60a6a2a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b60a6a2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b60a6a2a')) {
      api.createRecord('b60a6a2a', component.options)
    } else {
      api.reload('b60a6a2a', component.options)
    }
    module.hot.accept("./TableCmp.vue?vue&type=template&id=b60a6a2a&scoped=true", function () {
      api.rerender('b60a6a2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/basicData/cope/quotationManagement/cmp/CollectionForwardingCentreHomeDeliveryCmp/TableCmp.vue"
export default component.exports